import { gql } from '@apollo/client';

/**
 * Mutation to create a new rule
 * 
 * Usage:
 * ```tsx
 * const [createRule, { data, loading, error }] = useMutation(CREATE_RULE_MUTATION);
 * 
 * await createRule({
 *   variables: {
 *     input: {
 *       ruleName: 'My Rule',
 *       redirectUrl: 'https://example.com',
 *       priority: 'high'
 *     }
 *   }
 * });
 * ```
 */
export const CREATE_RULE_MUTATION = gql`
  mutation CreateRule($input: CreateRuleInput!) {
    createRule(input: $input) {
      success
      message
      ruleId
    }
  }
`;

